import { useSelector } from "react-redux";

export function SelectorCompanyName() {
  const companyName = useSelector((state) => state.manufacturer.companyName);
  return companyName;
}

export function SelectorListCountries() {
  const listCountries = useSelector(
    (state) => state.manufacturer.listCountries
  );
  return listCountries;
}

export function SelectorListStates() {
  const listStates = useSelector((state) => state.manufacturer.listStates);
  return listStates;
}

export function SelectorCompanyLogo() {
  const companyLogo = useSelector((state) => state.manufacturer.companyLogo);
  return companyLogo;
}

export function SelectorAddressLineOne() {
  const addressLineOne = useSelector(
    (state) => state.manufacturer.addressLineOne
  );
  return addressLineOne;
}

export function SelectorAddressLineTwo() {
  const addressLineTwo = useSelector(
    (state) => state.manufacturer.addressLineTwo
  );
  return addressLineTwo;
}

export function SelectorCountry() {
  const country = useSelector((state) => state.manufacturer.country);
  return country;
}

export function SelectorState() {
  const state = useSelector((state) => state.manufacturer.state);
  return state;
}

export function SelectorCity() {
  const city = useSelector((state) => state.manufacturer.city);
  return city;
}

export function SelectorPinCode() {
  const pinCode = useSelector((state) => state.manufacturer.pinCode);
  return pinCode;
}

export function SelectorErrorCompanyName() {
  const errorCompanyName = useSelector(
    (state) => state.manufacturer.errorCompanyName
  );
  return errorCompanyName;
}

export function SelectorErrorCompanyLogo() {
  const errorCompanyLogo = useSelector(
    (state) => state.manufacturer.errorCompanyLogo
  );
  return errorCompanyLogo;
}

export function SelectorErrorAddressLineOne() {
  const errorAddressLineOne = useSelector(
    (state) => state.manufacturer.errorAddressLineOne
  );
  return errorAddressLineOne;
}

export function SelectorErrorCountry() {
  const errorCountry = useSelector((state) => state.manufacturer.errorCountry);
  return errorCountry;
}

export function SelectorErrorState() {
  const errorState = useSelector((state) => state.manufacturer.errorState);
  return errorState;
}

///////////////////list Manufacturer//////////////////
export function SelectorListManufaturers() {
  const listManufaturers = useSelector(
    (state) => state.listManufacturer.listManufaturers
  );
  return listManufaturers;
}

export function SelectorDropdownManufaturers() {
  const dropdownManufaturers = useSelector(
    (state) => state.listManufacturer.dropdownManufaturers
  );
  return dropdownManufaturers;
}

export function SelectorDeleteID() {
  const deleteID = useSelector((state) => state.listManufacturer.deleteID);
  return deleteID;
}

export function SelectorSelected() {
  const selected = useSelector((state) => state.listManufacturer.selected);
  return selected;
}
